import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";

const SingleSelect = ({
  value,
  handleSingleSelectChange,
  options,
  className = "",
  error = null,
  placeholder = "Select option",
  disabled = false,
  panelClassName = "",
}) => {
  return (
    <div className="d-block">
      <Dropdown
        value={value}
        onChange={handleSingleSelectChange}
        options={options}
        optionLabel="name"
        placeholder={placeholder}
        className={`single_dropdown w-100 ${className}`}
        disabled={disabled}
        panelClassName={panelClassName}
      />
      {error && <div className="text-danger">{error}</div>}
    </div>
  );
};

export default SingleSelect;
